import { ResponsiveBar } from "@nivo/bar";
import { Box, Flex } from "@chakra-ui/react";
import LocalSpinner from "../../../../components/LocalSpinner";

const KpiCharts = ({
  currentYearData,
  previousYearData,
  isFetchingCurrentYear,
  isFetchingPreviousYear,
  selectedYear,
}) => {
  const CHART_COLORS = {
    [selectedYear]: "#718096",
    [selectedYear - 1]: "#CBD5E0",
  };

  return (
    <Box height="500px" width="100%">
      {isFetchingCurrentYear || isFetchingPreviousYear ? (
        <LocalSpinner />
      ) : (
        <ResponsiveBar /* or Bar for fixed dimensions */
          data={constructData(currentYearData, previousYearData, selectedYear)}
          keys={[selectedYear - 1, selectedYear]}
          indexBy="type"
          groupMode="grouped"
          label={false}
          legends={[
            {
              dataFrom: "keys",
              anchor: "bottom-right",
              direction: "column",
              translateX: 120,
              itemsSpacing: 3,
              itemWidth: 100,
              itemHeight: 16,
            },
          ]}
          animate={true}
          axisLeft={{ legend: "Total Emissions (TCO2e)", legendOffset: -70, legendPosition: "middle" }}
          margin={{ top: 50, right: 130, bottom: 80, left: 80 }}
          colors={({ id }) => CHART_COLORS[id]}
        />
      )}
    </Box>
  );
};

const constructData = (currentYearData, previousYearData, selectedYear) => {
  return [
    {
      type: "Scope 1",
      [selectedYear - 1]: previousYearData?.scope1Total || 0,
      [selectedYear]: currentYearData?.scope1Total || 0,
    },
    {
      type: "Scope 2 - Location",
      [selectedYear - 1]: previousYearData?.scope2LocationTotal || 0,
      [selectedYear]: currentYearData?.scope2LocationTotal || 0,
    },
    {
      type: "Scope 2 - Market",
      [selectedYear - 1]: previousYearData?.scope2MarketTotal || 0,
      [selectedYear]: currentYearData?.scope2MarketTotal || 0,
    },
    {
      type: "Scope 1 & 2 - Market",
      [selectedYear - 1]: previousYearData?.scope1AndScope2MarketTotal || 0,
      [selectedYear]: currentYearData?.scope1AndScope2MarketTotal || 0,
    },
    {
      type: "Scope 1 & 2 - Location",
      [selectedYear - 1]: previousYearData?.scope1AndScope2LocationTotal || 0,
      [selectedYear]: currentYearData?.scope1AndScope2LocationTotal || 0,
    },
    {
      type: "Scope 3",
      [selectedYear - 1]: previousYearData?.scope3Total || 0,
      [selectedYear]: currentYearData?.scope3Total || 0,
    },
  ];
};

export default KpiCharts;
